import React from 'react';

const isNumeric = value => !isNaN(parseFloat(value)) && isFinite(value);

export default class Percentage extends React.Component {
    render() {
        let x = this.props.x;
        let y = this.props.y;
        let value;
        
        if (this.props.status) {
            value = <span className="status-label">{this.props.status}</span>;
        } else if (!this.props.hasErrors && isNumeric(x) && isNumeric(y) && x <= y) {
            value = Math.round((x/y) * 100);
        } else {
            value = <span className="calculation-error-icon"><i className="material-icons">error</i></span>;
        }
        
        return <div className="percentage">{value}%</div>;
    }
}